<template>
  <div class="wrapper">
    <div class="row mt-2">
      <small class="form-text text-muted">Einbindung in die Vorlage via &lt;script src="tsparams.js"&gt;&lt;/script&gt;. Daten-Varialbe = tsparams (PDF Debugging, HTML Daten nicht löschen, mit "ts-report-debug")</small>
    </div>
    <div class="row mt-2">
      <div class="form-inline">
        <input type="text" class="form-control" v-model="name"/>
        <label class="ml-2 mr-2">=</label>
        <input type="text" class="form-control" v-model="defval"/>
      </div>
      <div class="form-inline ml-3">
        <select v-model="type" class="form-control mr-2">
          <option value="text">Text</option>
          <option value="date">Datum</option>
        </select>
        <button @click="addParam" class="btn btn-primary"><font-awesome-icon icon="plus"/></button>
      </div>
    </div>
    <div class="row">
      <div class="form-check">
        <label>
          <input type="checkbox" class="form-check-input" v-model="hide">
          Ausblenden
        </label>
      </div>
    </div>
    <hr/>
    <div class="row ml-3 mr-3 mb-2" v-for="(v,k) in params" :key="k">
      <div class="col-md">
        <span class="mr-3 pr-3">{{ k }} ({{v.type}})</span>
      </div>
      <div class="col-md">
        <div class="input-group">
          <input type="text" class="form-control" v-model="v.value"/>
          <div class="input-group-append">
            <button @click="remParam(k)" style="float:right;" class="btn btn-danger"><font-awesome-icon icon="trash"/></button>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="form-check">
          <label>
            <input type="checkbox" class="form-check-input" v-model="v.hide">
            Ausblenden
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportsParamView',
  props: ["params"],
  methods: {
    addParam: function() {
      console.log('add' + this.defval);
      var p = { type: this.type, value: this.defval, hide: !!this.hide };
      if (this.name == '') {
        this.$bvToast.toast('Bitte erst einen Namen eingeben.',{title: "Warnung",variant:"warning"});
        return;
      }
      this.params[this.name] = p;
      this.$forceUpdate();
    },
    remParam(key) {
      delete this.params[key];
      this.$forceUpdate();
    }
  },
  data() {
    return {
      name: "",
      type: "",
      defval: "",
    }
  }
}
</script>
